import { CloseRed } from '@/assets/icons';
import { PageSize, PageTypeEnum } from '@/constant';
import { NOOP } from '@/utils';
import { memo } from 'react';

import './style.scss';
import { FormikProvider } from 'formik';
import { included } from 'ramda-adjunct';

import { HeaderCreate, SelectDocumentInfo, UploadButton } from '..';
import Button from '../common/button';
import Loading from '../common/loading';
import TableWithActions from '../common/table/table-with-actions';
import { useLogic } from './define-document-upload.logic';
import ExpandableDocumentWrapper from './expandable-document-wrapper';

const DefineDocumentUploadView = () => {
	const {
		expandableDocumentWrapperRef,
		onSave,
		columns,
		fileUploadedDataSource,
		onClickUpload,
		uploadColumns,
		fileRowSelection,
		onDeleteLocalFile,
		fetching,
		listDocumentChangeFilterHidden,
		formik,

		_refTableId,
		_refTableName,
		converting,
		addNewDocument,
	} = useLogic();

	return (
		<FormikProvider value={formik as any}>
			<Loading isLoading={formik.isSubmitting} className="m-0 fixed" />
			<HeaderCreate
				title="서류 업로드"
				onClickCreate={onSave}
				titleSave="저장"
			/>
			<div className="bg-white">
				<div className="p-5">
					<div className="grid grid-cols-12 gap-10">
						<div className="col-span-4">
							<div className="py-[11px] border-b border-gray1 flex items-center gap-[10px]">
								<h1 className="text-[15px] font-medium text-font2">
									업로드 목록
								</h1>
								<span className="text-[11px] font-normal text-font8">
									업로드 가능 파일 확장자 : PDF, JPG, JPEG, PNG, HEIF, HEIC
								</span>
							</div>
							<div className="flex justify-between items-center mt-[15px] mb-[10px]">
								<Button
									className="!w-[60px] min-w-0 p-0 gap-1"
									onClick={onDeleteLocalFile}
								>
									<CloseRed width={16} height={16} />
									삭제
								</Button>
								<UploadButton
									onClickUpload={onClickUpload}
									className="!w-[54px] min-w-0"
								/>
							</div>

							<TableWithActions
								actionHidden
								columns={uploadColumns}
								dataSource={fileUploadedDataSource}
								rowKey={'id'}
								pagination={false}
								rowSelection={fileRowSelection}
								containerClassName="p-0 h-auto"
								scroll={{ y: 600 }}
								loading={converting}
							/>
						</div>
						<div className="col-span-8">
							<div className="py-[11px] border-b border-gray1">
								<h1 className="text-[15px] font-bold text-font2">서류 목록</h1>
							</div>

							<ExpandableDocumentWrapper
								ref={expandableDocumentWrapperRef}
								columns={columns}
								dataSource={listDocumentChangeFilterHidden}
								loading={fetching}
								addNewDocument={addNewDocument}
								searchComponent={
									<SelectDocumentInfo
										pageType={_refTableName}
										showActionsTop
										showCheckbox={
											!included(
												[PageTypeEnum.LODGING, PageTypeEnum.RECOMMENDER],
												_refTableName
											)
										}
										showIssuanceApplication={
											!included(
												[PageTypeEnum.LODGING, PageTypeEnum.RECOMMENDER],
												_refTableName
											)
										}
										showApplicant={false}
										showProgram
										refTableId={Number(_refTableId)}
										page={{
											current: 1,
											pageSize: PageSize.M,
										}}
										setPage={NOOP}
										fromDefineUpload
										callApiMapping
										getDefineDocumentUploadListCallback={() => {
											requestAnimationFrame(() => {
												expandableDocumentWrapperRef.current?.toggleAll();
											});
										}}
									/>
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</FormikProvider>
	);
};

export default memo(DefineDocumentUploadView);
